/**
 * Revia staff — the members of Revia's own organization, and the authority
 * every backoffice record is gated on.
 *
 * `REVIA_ORG_ID` — the organization Revia's records live under:
 *   `workspaces/revia/…`. One database serves Revent's organizations and
 *   Revia's, so Revia is an organization like any other, with its own card,
 *   storefront, members and roles.
 *
 * `STAFF_PERMISSION` — the permission a staff member holds in that
 *   organization to read and decide access requests and sign licences.
 *   Every Revia entity names it with `{ workspace: REVIA_ORG_ID }`,
 *   so the emitted rule reads the caller's grant at `users/{uid}/grants/revia`
 *   whatever path the document sits on. Approving a request admits a new
 *   founder, the platform-wide form of inviting a member, so it is the
 *   catalog's member-invite permission rather than a token of Revia's own.
 */
export const REVIA_ORG_ID = "revia";

export const STAFF_PERMISSION = "tickets.members.invite";

/**
 * `STAFF_NOTICE_VERSION` — the version of the staff data-protection notice a
 *   staff member acknowledges before the backoffice admits them; their
 *   acknowledgment is `workspaces/revia/staffNotices/{uid}/versions/{this}`.
 *   Dated for the notice text it names (`staff-notice.text.ts`); a change to
 *   that text takes a new date, and every staff member acknowledges again
 *   under it.
 */
export const STAFF_NOTICE_VERSION = "2026-10-21";
